const TOKEN_KEY = 'access_token'
const USER = 'access_user'
const EMAIL = 'access_email'
const BILL = 'access_bill'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY)
  },
  getUser() {
    return localStorage.getItem(USER)
  },
  getEmail() {
    return localStorage.getItem(EMAIL)
  },
  getBill() {
    return localStorage.getItem(BILL)
  },
  saveToken(accessToken, accessUser) {
    localStorage.setItem(TOKEN_KEY, accessToken)
    localStorage.setItem(USER, accessUser)
  },
  saveEmail(accessEmail) {
    localStorage.setItem(EMAIL, accessEmail)
  },
  saveBill(accessBill) {
    localStorage.setItem(BILL, accessBill)
  },
  removeToken() {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER)
  },
  removeEmail() {
    localStorage.removeItem(EMAIL)
  },
  removeBill() {
    localStorage.removeItem(BILL)
  },
}

export { TokenService }